export enum QueryOperator {
  Match = 1, // plain text
  Exists = 2, // no value
  DoesNotExists = 3, // no value
  Includes = 4, // multi-select
  Excludes = 5, // multi-select
  Range = 7, // start - end inputs -> date or number
  LessThan = 8,
  LessOrEqualThan = 9,
  GreaterThan = 10,
  GreaterOrEqualThan = 11
}
